import React, { useEffect } from 'react';
import $ from 'jquery';
import 'slick-carousel';

function TestimonialSection() {
  const imgs = [
    '/project/images/testimonal-img-1.jpg',
    '/project/images/testimonal-img-1.jpg',
    '/project/images/testimonal-img-1.jpg',
    '/project/images/testimonal-img-1.jpg',
  ];

  useEffect(() => {
    const $slider = $('.testimonal-silder');
    if ($slider.length) {
      $slider.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true,
        responsive: [
          { breakpoint: 992, settings: { slidesToShow: 2 } },
          { breakpoint: 768, settings: { slidesToShow: 1 } }
        ]
      });
    }

    // Optional: cleanup on unmount
    return () => {
      if ($slider.length && $slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    };
  }, []);

  return (
    <section className="testimonal-sec pt-6 pb-6">
      <div className="container">
        <div className="about-text text-center mb-5">
          <h2>Our Google Reviews</h2>
        </div>

        <div className="testimonal-silder">
          {imgs.map((src, i) => (
            <div className="testimonal-box" key={i}>
              <img src={src} alt={`Testimonial ${i + 1}`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TestimonialSection;
